
import React, { Component } from 'react';
import { Modal, Form, Input, Switch } from 'antd';

import http from '../../../axios/http';
import validator from '../../../util/validator'
import messager from '../../ui/messager';

const fields = [{
    "text": "类型编码",
    "field": "category",
    rules: [
        { required: true, message: '请输入类型编码!' },
        validator.lineEn,
        { max: 32, message: '最多只能输入32个字符！' }
    ]
}, {
    "text": "类型名称",
    "field": "name",
    rules: [
        { required: true, message: '请输入类型名称!' },
        { max: 32, message: '最多只能输入32个字符！' }
    ]
}, {
    "text": "是否树形字典",
    "field": "treeDict",
    "radio": true,
}];

class DictCategoryEditForm extends Component {

    state = {
        orgTree: [],
        menuTree: []
    }


    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["oldCategory"] = this.props.editData["category"];
            values["treeDict"] = values["treeDict"] ? 1 : 0;
            http.post({
                url: '/dict/saveCategory',
                data: values,
                success: (res) => {
                    this.props.successCallback();
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let domItem = "";
            domItem = (
                <Form.Item label={item.text + "："} key={i}>
                    {getFieldDecorator(item.field, {
                        rules: item.rules,
                        initialValue: item.radio ? editData[item.field] === 1 : editData[item.field],
                        valuePropName: item.radio ? 'checked' : 'value'
                    })(
                        item.radio ? <Switch checkedChildren="是" unCheckedChildren="否" disabled={editData["category"] != null}/>
                            : <Input />
                    )}
                </Form.Item>
            );
            dom.push(domItem);
        }
        return dom;
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="字典类型编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const DictCategoryEdit = Form.create()(DictCategoryEditForm);

export default DictCategoryEdit;